import { useMediaQuery, useTheme } from "@mui/material";
import MobileLayout from "./mobile/mobile-layout";
import DesktopLayout from "./desktop/desktop-layout";

interface Props {
  children: React.ReactNode;
}

const ResponsiveLayout = ({ children }: Props) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return isMobile ? (
    <MobileLayout>{children}</MobileLayout>
  ) : (
    <DesktopLayout>{children}</DesktopLayout>
  );
};

export default ResponsiveLayout;
